import { RadioGroup as MuiRadioGroup } from '@material-ui/core'

import type { RadioGroupProps } from './types'

export default function RadioGroup(props: RadioGroupProps) {
  return <MuiRadioGroup {...props} />
}
